
import toastr from "toastr"

toastr.options = {
  timeOut: 10000,
  extendedTimeOut: 5000,
  closeButton: false,
}

export const toast = {
  success: (
    message = '성공했습니다.',
    title,
    options = {}
  ) => {
    toastr.success(message, title, {
      ...options
    })
  },
  info: (
    message,
    title,
    options = {}
  ) => {
    toastr.info(message, title, {
      ...options
    })
  },
  warning: (
    message,
    title,
    options = {}
  ) => {
    toastr.warning(message, title, {
      ...options
    })
  },
  error: (
    message = '실패했습니다.',
    title,
    options = {}
  ) => {
    toastr.error(message, title, {
      timeOut: 60000,
      extendedTimeOut: 10000,
      ...options
    })
  },
}